var _a;
export var CSS = 'css';
export var ANDROID = 'android';
export var SWIFT = 'swift';
export var OBJECTIVE_C = 'objective-c';
export var LABELS = (_a = {},
    _a[CSS] = 'CSS',
    _a[ANDROID] = 'Android (XML)',
    _a[SWIFT] = 'Swift',
    _a[OBJECTIVE_C] = 'Objective-C',
    _a);
